<ng-container *transloco="let t">
    <section *ngIf="!showHelpText; else info">
        <h1>{{ t("auth.account-setup.header") }}</h1>
        <form [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
            <input
                type="hidden"
                formControlName="receivesNotifications"
                value="true"
            />

            <mat-form-field appearance="outline">
                <mat-label>{{ t("auth.account-setup.firstName") }}</mat-label>
                <input matInput formControlName="firstName" maxlength="50" />
                <mat-error *ngIf="firstName?.hasError('required')">
                    {{ t("auth.account-setup.firstNameRequired") }}
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>{{ t("auth.account-setup.lastName") }}</mat-label>
                <input matInput formControlName="lastName" maxlength="50" />
                <mat-error *ngIf="lastName?.hasError('required')">
                    {{ t("auth.account-setup.lastNameRequired") }}
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>{{
                    t("auth.account-setup.emailOrPhone")
                }}</mat-label>
                <input
                    matInput
                    formControlName="emailOrPhone"
                    maxlength="200"
                />
                <mat-error *ngIf="emailOrPhone?.hasError('required')">
                    {{ t("auth.account-setup.emailOrPhoneRequired") }}
                </mat-error>
                <mat-error *ngIf="emailOrPhone?.hasError('email')">
                    {{ t("auth.account-setup.emailInvalid") }}
                </mat-error>
                <mat-error *ngIf="emailOrPhone?.hasError('invalidPhoneNumber')">
                    {{ t("auth.account-setup.phoneInvalid") }}
                </mat-error>
            </mat-form-field>

            <small [innerHTML]="client?.signUpFooterHtml"></small>

            <mat-checkbox formControlName="agree">
                {{ t("auth.account-setup.agreementLabel.1") }}
                <a href="javascript:void(0)" (click)="displayInfo('terms')">{{
                    t("shared.link.terms-of-use")
                }}</a>
                {{ t("auth.account-setup.agreementLabel.2") }}
                <a href="javascript:void(0)" (click)="displayInfo('privacy')">{{
                    t("shared.link.privacy-policy")
                }}</a
                >.
                <mat-error
                    *ngIf="agree?.hasError('required') && agree?.touched"
                >
                    {{ t("auth.account-setup.agreementRequired") }}
                </mat-error>
            </mat-checkbox>

            <div class="actions">
                <button type="button" mat-button (click)="goBack()">
                    <mat-icon color="accent">arrow_back</mat-icon>
                    {{ t("shared.go-back") | uppercase }}
                </button>
                <button
                    type="submit"
                    mat-raised-button
                    color="accent"
                    [disabled]="formGroup.invalid"
                >
                    {{ t("shared.continue") | uppercase }}
                </button>
            </div>
        </form>
    </section>

    <ng-template #info>
        <section class="service-unavailable">
            <ng-container *ngIf="displayTerms">
                <app-terms-of-use></app-terms-of-use>
            </ng-container>
            <ng-container *ngIf="displayPrivacy">
                <app-privacy-policy></app-privacy-policy>
            </ng-container>
            <button type="button" mat-button (click)="goBackPrevious()">
                <mat-icon color="accent">arrow_back</mat-icon>
                {{ t("shared.go-back") | uppercase }}
            </button>
        </section>
    </ng-template>
</ng-container>
